import { IPagination, IPaginationRequest } from "interfaces/pagination";
import { IRole } from "interfaces/user";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Header from "components/common/Header";
import Swal from "sweetalert2";
import Table from "components/common/Table";
import Typography from "@mui/material/Typography";
import useAlert from "hooks/useAlert";
import useToken from "hooks/useToken";
import withAuth from "hocs/withAuth";
import withPermission from "hocs/withPermission";
import WarrantyServices from "services/taylormadeWarranty";
import dayjs from "dayjs";

interface IDealersData {
  id: number;
  name: string;
  createdat: string;
}
interface IPaginationTaylorMade {
  page: number;
  total: number;
  totalPages: number;
}

const ListDealers = () => {
  const { token } = useToken();
  const { onAlert } = useAlert();
  const [data, setData] = useState<{
    data: IDealersData[];
    pagination: IPagination;
  }>({
    data: [],
    pagination: {
      page: 1,
      total_item: 0,
      total_page: 0,
    },
  });
  const [pagination, setPagination] = useState<IPaginationRequest>({
    page: 1,
    per_page: 10,
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  const fetchData = () => {
    WarrantyServices.getAllDealers(token as string, {
      per_page: pagination.per_page,
      page: pagination.page,
    })
      .then((res) => {
        let paginationRes: IPaginationTaylorMade = res.data.meta;
        setData({
          data: res.data.data.map((d: IDealersData) => {
            return {
              id: d.id,
              name: d.name,
              createdat: d.createdat,
            };
          }),
          pagination: {
            page: paginationRes.page,
            total_item: paginationRes.total,
            total_page: paginationRes.totalPages,
          },
        });
        setIsLoading(false);
      })
      .catch((err) => {
        onAlert("error", err.response.data.message);
      });
  };

  const onDelete = (item: IRole) => {
    Swal.fire({
      icon: "warning",
      html: `ต้องการลบ Dealers <b>${item.name}</b> ใช่ หรือไม่?`,
      showCancelButton: true,
      confirmButtonText: "ลบ",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        WarrantyServices.deleteDealer(token as string, item.id)
          .then((res) => {
            onAlert("success", "ลบ Dealers สำเร็จ");
            fetchData();
          })
          .catch((err) => {
            onAlert("error", err.response.data.message);
          });
      }
    });
  };

  return (
    <>
      <Header
        title="Dealers"
        actions={[
          <Link to="/taylormade/dealers/create">
            <Button variant="contained" size="large">
              <AddIcon
                sx={{
                  fontSize: 14,
                  mr: 1,
                }}
              />
              <Typography>Create</Typography>
            </Button>
          </Link>,
        ]}
        breadcrumbs={[
          {
            label: "Dealers",
            href: "/taylormade/dealers/list",
          },
          {
            label: "List",
          },
        ]}
      />
      <Table
        headers={[
          {
            key: "name",
            label: "Dealers name",
          },
          {
            key: "createdat",
            label: "Create Date",
            render: (value) => {
              return dayjs(value).format("DD/MM/YYYY");
            },
          },
        ]}
        actions={{
          onDelete: (item: any) => onDelete(item),
        }}
        data={data.data}
        isLoading={isLoading}
        pagination={
          data.pagination
            ? {
                ...data.pagination,
                onChange: (page) =>
                  setPagination((pagination) => {
                    return {
                      ...pagination,
                      page,
                    };
                  }),
              }
            : undefined
        }
      />
    </>
  );
};

export default withAuth(
  withPermission(ListDealers, "MANAGE_TAYLORMADE_WARRANTY"),
);
